import { render, staticRenderFns } from "./MadaTemp.vue?vue&type=template&id=f3852bd0&"
import script from "./MadaTemp.vue?vue&type=script&lang=js&"
export * from "./MadaTemp.vue?vue&type=script&lang=js&"
import style0 from "./MadaTemp.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports